import { render, staticRenderFns } from "./ViewFiles.vue?vue&type=template&id=3118421a&"
import script from "./ViewFiles.vue?vue&type=script&lang=js&"
export * from "./ViewFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports